import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestDataAccessService } from './request-data-access.service';
import { RequestRoot } from 'types';

@Injectable()
export class InMemoryRequestDataAccessService implements RequestDataAccessService {
  count(filter: Object): Observable<number> {
    throw new Error('Method not implemented.');
  }
  find(query: Object): Observable<RequestRoot[]> {
    throw new Error('Method not implemented.');
  }
  load(request: RequestRoot): Observable<RequestRoot> {
    throw new Error('Method not implemented.');
  }
  createUID(): Observable<string> {
    throw new Error('Method not implemented.');
  }
  save(request: RequestRoot): Observable<void> {
    throw new Error('Method not implemented.');
  }
  edit(request: RequestRoot): Observable<void> {
    throw new Error('Method not implemented.');
  }
  wipe(request: RequestRoot): Observable<void> {
    throw new Error('Method not implemented.');
  }
}
